export const THEME_TOKEN_KEYS = [
	'background',
	'foreground',
	'card',
	'card-foreground',
	'popover',
	'popover-foreground',
	'primary',
	'primary-foreground',
	'secondary',
	'secondary-foreground',
	'muted',
	'muted-foreground',
	'accent',
	'accent-foreground',
	'destructive',
	'destructive-foreground',
	'border',
	'input',
	'ring',
	'chart-1',
	'chart-2',
	'chart-3',
	'chart-4',
	'chart-5',
	'sidebar',
	'sidebar-foreground',
	'sidebar-primary',
	'sidebar-primary-foreground',
	'sidebar-accent',
	'sidebar-accent-foreground',
	'sidebar-border',
	'sidebar-ring',
	'font-sans',
	'font-serif',
	'font-mono',
	'radius',
	'shadow-x',
	'shadow-y',
	'shadow-blur',
	'shadow-spread',
	'shadow-opacity',
	'shadow-color',
	'shadow-2xs',
	'shadow-xs',
	'shadow-sm',
	'shadow',
	'shadow-md',
	'shadow-lg',
	'shadow-xl',
	'shadow-2xl',
	'tracking-normal',
	'spacing',
	'study-progress-not-started',
	'study-progress-in-progress',
	'study-progress-completed',
	'study-progress-deadline',
	'surface',
	'surface-elevated',
	'media',
	'overlay',
	'status-success-surface',
	'status-success-text',
	'status-success-border',
	'status-warning-surface',
	'status-warning-text',
	'status-warning-border',
	'status-danger-surface',
	'status-danger-text',
	'status-danger-border',
	'status-info-surface',
	'status-info-text',
	'status-info-border',
	'success',
	'warning',
	'info',
	'danger',
	'carousel-slide-0',
	'carousel-slide-0-foreground',
	'carousel-slide-1',
	'carousel-slide-1-foreground',
	'carousel-slide-2',
	'carousel-slide-2-foreground',
	'carousel-slide-3',
	'carousel-slide-3-foreground',
	'carousel-slide-4',
	'carousel-slide-4-foreground',
	'reading-foreground',
	'border-strong',
	'gold',
	'gold-text',
	'gold-wash',
] as const

export type ThemeTokenKey = (typeof THEME_TOKEN_KEYS)[number]
export type ThemeTokenRecord = Record<ThemeTokenKey, string>

export type AppearanceThemeMode = 'light' | 'dark' | 'system'
export type ResolvedAppearanceThemeMode = 'light' | 'dark'
export type BrandStylePresetKey = string

export type BrandThemePreset = {
	key: BrandStylePresetKey
	label: string
	description: string
	tokens: {
		light: ThemeTokenRecord
		dark: ThemeTokenRecord
	}
}

export type BrandThemeDefinition = {
	brandKey: string
	defaultPreset: BrandStylePresetKey
	presets: Record<BrandStylePresetKey, BrandThemePreset>
}

export type BrandStylePresetSummary = Pick<
	BrandThemePreset,
	'key' | 'label' | 'description'
>

export type ResolvedAppearanceTokens = {
	brandKey: string
	stylePreset: BrandStylePresetKey
	theme: AppearanceThemeMode
	resolvedTheme: ResolvedAppearanceThemeMode
	tokens: ThemeTokenRecord
}
